import {Box} from '@primer/react'

import styles from './ControlGroupContainer.module.css'

type ControlGroupContainerProps = {
  children: React.ReactNode
  border?: boolean
  fullWidth?: boolean
  ['data-testid']?: string
}

const ControlGroupContainer = ({
  children,
  fullWidth = false,
  border = true,
  'data-testid': testId,
}: ControlGroupContainerProps) => {
  return (
    <Box
      sx={{
        '--controlgroup_item-gap': fullWidth ? 'var(--base-size-24)' : 'var(--base-size-12)',
        borderColor: border ? 'border.muted' : 'transparent',
      }}
      data-testid={testId}
      className={styles.Box}
    >
      {children}
    </Box>
  )
}

export default ControlGroupContainer

try{ ControlGroupContainer.displayName ||= 'ControlGroupContainer' } catch {}